import OrderSellerRemarksFlag from "@/enum/OrderSellerRemarksFlag";
import mainServerClient from "@/services/http/mainServerClient";

export interface ScanPrintingSetting {
    checkBuyerRemarks?: boolean;
    checkLockedOrder?: boolean;
    checkRefundingOrder?: boolean;
    checkSellerRemarks?: boolean;
    checkSpecificSellerFlag?: boolean;
    checkWaybillPrintedOrder?: boolean;
    companyId?: number;
    specificSellerFlags?: OrderSellerRemarksFlag[];
}

export function getScanPrintingSetting(): Promise<ScanPrintingSetting> {
    return mainServerClient.get("/scan_printing_setting/get");
}

export function saveScanPrintingSetting(scanPrintingSetting: ScanPrintingSetting): Promise<ScanPrintingSetting> {
    return mainServerClient.post("/scan_printing_setting/save", scanPrintingSetting);
}
